import * as Yup from 'yup';
export const PurchaseRegistrationSchema = Yup.object().shape({
  state: Yup.string().required('عنوان  اجباری می باشد'),
  city: Yup.string().required('عنوان  اجباری می باشد'),
  hide_phone_number: Yup.boolean().required('عنوان  اجباری می باشد'),
  title: Yup.string().required('عنوان  اجباری می باشد'),
});
